import React from 'react';
import type { ClassMemberGradeLayout } from '../../utils/classMembersStorage';
import { firstRecordGroupId } from '../../utils/classMemberRecordGroupUtils';

type Props = {
  layout: ClassMemberGradeLayout;
  value: string | null;
  onChange: (groupId: string | null) => void;
  disabled?: boolean;
  id?: string;
  /**
   * true: 그룹이 하나도 없으면 선택 비활성화(기존 requireGroup 의 "그룹 없음" 케이스만 유지).
   * 첫 옵션은 항상 value="" 로 비움(그룹 선택 해제 등).
   */
  requireGroup?: boolean;
  /** value 가 비었을 때 상단 옵션에 보이는 문구 */
  clearOptionLabel?: string;
  /** 래퍼에 붙는 클래스(예: 평가기록 모드에서 드롭다운 너비 조절) */
  wrapClassName?: string;
};

const RecordMemberGroupSelect: React.FC<Props> = ({
  layout,
  value,
  onChange,
  disabled,
  id,
  requireGroup = false,
  clearOptionLabel = '그룹 선택 해제',
  wrapClassName,
}) => {
  const sorted = [...layout.groups].sort(
    (a, b) => a.sortOrder - b.sortOrder || a.name.localeCompare(b.name, 'ko') || a.id.localeCompare(b.id)
  );
  const firstId = firstRecordGroupId(layout);
  const v = (value ?? '').trim();
  const valid = v && sorted.some((g) => g.id === v);
  const selectValue = valid ? v : '';

  return (
    <div className={['cp-record-member-group-select-wrap', wrapClassName].filter(Boolean).join(' ')}>
      <label htmlFor={id} className="cp-record-member-group-select-label">
        멤버 그룹
      </label>
      <select
        id={id}
        className="cp-record-member-group-select"
        value={selectValue}
        disabled={disabled || (requireGroup && !firstId)}
        onChange={(e) => {
          const next = e.target.value.trim();
          onChange(next ? next : null);
        }}
      >
        <option value="">{clearOptionLabel}</option>
        {sorted.map((g) => (
          <option key={g.id} value={g.id}>
            {(g.name ?? '').trim() || g.id}
          </option>
        ))}
      </select>
    </div>
  );
};

export default RecordMemberGroupSelect;
